<script>
import { mapState } from 'vuex'
export default {
  name: 'RouteView',
  props: {
    keepAlive: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      aliveComponents: state => state.multTabStore.aliveComponents
    })
  },
  render () {
    const { $route: { meta } } = this
    const inKeep = (
      <keep-alive include={this.aliveComponents}>
        <router-view />
      </keep-alive>
    )
    const notKeep = (
      <router-view />
    )

    if (meta.unkeep) {
      return notKeep
    }
    return this.keepAlive ? inKeep : notKeep
  }
}
</script>

<style scoped>
</style>